export const getGridItemWidth = (columns: number, gap: number) =>
  `repeat(${columns}, calc(100% / ${columns} - (${gap * (columns - 1)}px / ${columns})))`;
